import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { PasquaMylibComponent } from './pasqua-mylib.component';
import { MaterialModule } from './modules/material/material.module';
import { AppHeaderComponent } from './components/app-header/app-header.component';

const componentiLibreria = [
   PasquaMylibComponent,
   AppHeaderComponent
];

@NgModule({
  declarations: [
   componentiLibreria
  ],

  imports: [
   MaterialModule
  ],

  exports: [
   componentiLibreria
  ],

  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]

})
export class PasquaMylibModule { }
